import type {
  CreateInstitutePayload,
  InstituteFormValues,
  InstituteDetail,
} from '../types/institute.types';

export const EMPTY_INSTITUTE_FORM_DEFAULTS: InstituteFormValues = {
  name: '',
  nameBn: '',
  description: '',
  instituteTypeId: 0,
  examBoardId: 0,
  geoUnitId: 0,
  eiinNumber: '',
  contactName: '',
  contactNumber: '',
  startDate: '',
  endDate: '',
  isActive: true,
};

export function buildInstitutePayload(values: InstituteFormValues): CreateInstitutePayload {
  const payload: CreateInstitutePayload = {
    name: values.name,
    instituteTypeId: values.instituteTypeId,
    examBoardId: values.examBoardId,
    geoUnitId: values.geoUnitId,
    contactName: values.contactName,
    contactNumber: values.contactNumber,
    startDate: values.startDate,
    endDate: values.endDate,
    isActive: values.isActive,
  };
  const nameBn = values.nameBn.trim();
  if (nameBn) payload.nameBn = nameBn;
  const description = values.description.trim();
  if (description) payload.description = description;
  const eiinNumber = values.eiinNumber.trim();
  if (eiinNumber) payload.eiinNumber = eiinNumber;
  return payload;
}

function toDateInputValue(value: Date | null): string {
  if (!value) return '';
  if (Number.isNaN(value.getTime())) return '';
  return value.toISOString().slice(0, 10);
}

export function mapInstituteToFormValues(institute: InstituteDetail): InstituteFormValues {
  return {
    name: institute.name,
    nameBn: institute.nameBn ?? '',
    description: institute.description ?? '',
    instituteTypeId: institute.instituteTypeId ?? 0,
    examBoardId: institute.examBoardId ?? 0,
    geoUnitId: institute.geo?.thana?.id ?? 0,
    eiinNumber: institute.eiinNumber ?? '',
    contactName: institute.contactName ?? '',
    contactNumber: institute.contactNumber ?? '',
    startDate: toDateInputValue(institute.startDate),
    endDate: toDateInputValue(institute.endDate),
    isActive: institute.status === 'active',
  };
}

export function extractInstituteCascade(institute: InstituteDetail): {
  divisionId: number | undefined;
  districtId: number | undefined;
} {
  return {
    divisionId: institute.geo?.division?.id ?? undefined,
    districtId: institute.geo?.district?.id ?? undefined,
  };
}
